export type SlotPositionOption = {
  value: string;
  label: string;
};

export const SLOT_POSITION_OPTIONS: SlotPositionOption[] = [
  { value: 'START', label: 'Start' },
  { value: 'END', label: 'End' },
];

/**
 * Targeting Manager `mC_Country` codes treated as EMEA for the Sequence slot-position default.
 *
 * Keep in sync with order-manager `EmeaCountryCodes`, which uses the same set server-side for
 * EMEA sequence pod positioning; this list is that set plus the EMEA ad tier expansion markets.
 */
export const EMEA_COUNTRIES = [
  // Belgium, Denmark (incl. Faroe Islands, Greenland), Finland (incl. Åland Islands)
  'BE',
  'DK',
  'FO',
  'GL',
  'FI',
  'AX',
  // France, Monaco, and French overseas territories
  'FR',
  'TF',
  'GF',
  'PF',
  'MF',
  'GP',
  'MQ',
  'MU',
  'YT',
  'MC',
  'NC',
  'RE',
  'BL',
  'PM',
  'SX',
  'WF',
  // Germany, Ireland, Italy (incl. Vatican City, San Marino), Netherlands, Norway (incl. Svalbard)
  'DE',
  'IE',
  'IT',
  'VA',
  'SM',
  'NL',
  'NO',
  'SJ',
  // Portugal, Spain, Sweden, Switzerland, Turkey
  'PT',
  'ES',
  'SE',
  'CH',
  'TR',
  // United Kingdom and British Crown Dependencies / Overseas Territories
  'GB',
  'IO',
  'GI',
  'GG',
  'IM',
  'JE',
  'PN',
  'SH',
  // EMEA ad tier expansion markets
  'PL',
  'AT',
  'ZA',
  'SA',
  'AE',
];

export const UNSELECTED_SLOT_POSITION: SlotPositionOption = { value: '', label: '-- Select --' };

/**
 * Returns the default slot position for a sequence row.
 *
 * Defaults to `'END'` only when every targeted country is in EMEA. An empty or
 * null `countries` list is treated as not-EMEA (defaults to `'START'`), matching
 * the legacy single-country behavior where a missing country also defaulted to
 * `'START'`.
 */
export const getDefaultSlotPosition = (countries?: ReadonlyArray<string | null | undefined> | null): string => {
  return countries?.length && countries.every((c): c is string => c != null && EMEA_COUNTRIES.includes(c))
    ? 'END'
    : 'START';
};
